<template>
  <div class="setup-price">
    <BasePrice :contentOwnership="contentOwnership" :partOfBundle="partOfBundle" />
    <RegionalPricing
      v-if="countries && contentOwnership.currentPrices"
      :contentOwnership="contentOwnership"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import BasePrice from './content-fields/BasePrice';
import RegionalPricing from './content-fields/RegionalPricing';
import store from '@/core/store';

@Component({
  components: {
    BasePrice,
    RegionalPricing,
  },
  props: {
    contentOwnership: {
      type: Object,
      required: true,
    },
  },
  data: () => {
    return {
      partOfBundle: false,
    };
  },
})
export default class SetupPrice extends Vue {
  get countries () {
    return store.getters['entities/Country/all']();
  }

  async mounted () {
    const bundles = await this.$store.dispatch('activeBundlesByContentOwnership', this.contentOwnership.id);
    this.partOfBundle = bundles.length > 0;
  }
}
</script>
